"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var DeleteUnpublishedLink =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DeleteUnpublishedLink, _PureComponent);

  function DeleteUnpublishedLink() {
    (0, _classCallCheck2.default)(this, DeleteUnpublishedLink);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DeleteUnpublishedLink).apply(this, arguments));
  }

  (0, _createClass2.default)(DeleteUnpublishedLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          labelLangKey = _this$props.labelLangKey;
      return _react.default.createElement(_UILink.default, {
        onClick: onClick
      }, _react.default.createElement(_UIIcon.default, {
        name: "delete"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: labelLangKey
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        labelLangKey: _react.PropTypes.string.isRequired,
        onClick: _react.PropTypes.func
      };
    }
  }]);
  return DeleteUnpublishedLink;
}(_react.PureComponent);

exports.default = DeleteUnpublishedLink;
module.exports = exports.default;